module.exports = __webpack_public_path__ + "img/image.4326e0b2.jpg";